export default __webpack_public_path__ + "static/media/spendCategoryUncategorised32.6859b404.svg";